export default {
  kw: 'kW',
};



// WEBPACK FOOTER //
// ./js/lang/nl/units.js